function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import { DatetimeField } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1mn76l5-DateTimeControl",
  styles: "font-size:0.8em;color:#666;label:DateTimeControl;"
} : {
  name: "1mn76l5-DateTimeControl",
  styles: "font-size:0.8em;color:#666;label:DateTimeControl;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9EYXRlVGltZUNvbnRyb2wuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUpvQiIsImZpbGUiOiIuLi8uLi9zcmMvRGF0ZVRpbWVDb250cm9sLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgZGF5anMgZnJvbSAnZGF5anMnO1xuaW1wb3J0IGN1c3RvbVBhcnNlRm9ybWF0IGZyb20gJ2RheWpzL3BsdWdpbi9jdXN0b21QYXJzZUZvcm1hdCc7XG5pbXBvcnQgbG9jYWxpemVkRm9ybWF0IGZyb20gJ2RheWpzL3BsdWdpbi9sb2NhbGl6ZWRGb3JtYXQnO1xuaW1wb3J0IHV0YyBmcm9tICdkYXlqcy9wbHVnaW4vdXRjJztcbmltcG9ydCB7IERhdGV0aW1lRmllbGQgfSBmcm9tICdkZWNhcC1jbXMtdWktbmV4dCc7XG5cbmRheWpzLmV4dGVuZChjdXN0b21QYXJzZUZvcm1hdCk7XG5kYXlqcy5leHRlbmQobG9jYWxpemVkRm9ybWF0KTtcbmRheWpzLmV4dGVuZCh1dGMpO1xuXG5jbGFzcyBEYXRlVGltZUNvbnRyb2wgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGZpZWxkOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gICAgZm9ySUQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgb25DaGFuZ2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gICAgY2xhc3NOYW1lV3JhcHBlcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgIHNldEFjdGl2ZVN0eWxlOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICAgIHNldEluYWN0aXZlU3R5bGU6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gICAgdmFsdWU6IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5vYmplY3QsIFByb3BUeXBlcy5zdHJpbmddKSxcbiAgICB0OiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICAgIGlzRGlzYWJsZWQ6IFByb3BUeXBlcy5ib29sLFxuICB9O1xuXG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgaXNEaXNhYmxlZDogZmFsc2UsXG4gIH07XG5cbiAgaXNVdGMgPSB0aGlzLnByb3BzLmZpZWxkLmdldCgncGlja2VyX3V0YycpIHx8IGZhbHNlO1xuXG4gIGVzY2FwZVooc3RyKSB7XG4gICAgaWYgKC9aKD8hW1xcXV0pLy50ZXN0KHN0cikpIHtcbiAgICAgIHJldHVybiBzdHIucmVwbGFjZSgnWicsICdbWl0nKTtcbiAgICB9XG4gICAgcmV0dXJuIHN0cjtcbiAgfVxuXG4gIGdldEZvcm1hdCgpIHtcbiAgICBjb25zdCB7IGZpZWxkIH0gPSB0aGlzLnByb3BzO1xuICAgIGxldCBpbnB1dFR5cGUgPSAnZGF0ZXRpbWUtbG9jYWwnO1xuICAgIGxldCBpbnB1dEZvcm1hdCA9ICdZWVlZLU1NLUREVEhIOm1tJztcbiAgICBsZXQgZm9ybWF0ID0gJ1lZWVktTU0tRERUSEg6bW06c3MuU1NTW1pdJztcbiAgICBsZXQgdXNlckZvcm1hdCA9IGZpZWxkPy5nZXQoJ2Zvcm1hdCcpO1xuICAgIGxldCBkYXRlRm9ybWF0ID0gZmllbGQ/LmdldCgnZGF0ZV9mb3JtYXQnKTtcbiAgICBsZXQgdGltZUZvcm1hdCA9IGZpZWxkPy5nZXQoJ3RpbWVfZm9ybWF0Jyk7XG4gICAgaWYgKGRhdGVGb3JtYXQgPT09IHRydWUpIGRhdGVGb3JtYXQgPSAnWVlZWS1NTS1ERCc7XG4gICAgaWYgKHRpbWVGb3JtYXQgPT09IHRydWUpIHRpbWVGb3JtYXQgPSAnSEg6bW0nO1xuXG4gICAgaWYgKHRoaXMuaXNVdGMpIHtcbiAgICAgIHVzZXJGb3JtYXQgPSB0aGlzLmVzY2FwZVoodXNlckZvcm1hdCk7XG4gICAgICBkYXRlRm9ybWF0ID0gdGhpcy5lc2NhcGVaKGRhdGVGb3JtYXQpO1xuICAgICAgdGltZUZvcm1hdCA9IHRoaXMuZXNjYXBlWih0aW1lRm9ybWF0KTtcbiAgICB9XG5cbiAgICBpZiAodHlwZW9mIGRhdGVGb3JtYXQgPT09ICdzdHJpbmcnICYmIHR5cGVvZiB0aW1lRm9ybWF0ID09PSAnc3RyaW5nJykge1xuICAgICAgZm9ybWF0ID0gYCR7ZGF0ZUZvcm1hdH1UJHt0aW1lRm9ybWF0fWA7XG4gICAgfSBlbHNlIGlmICh0eXBlb2YgdGltZUZvcm1hdCA9PT0gJ3N0cmluZycpIHtcbiAgICAgIGlucHV0VHlwZSA9ICd0aW1lJztcbiAgICAgIGZvcm1hdCA9IHRpbWVGb3JtYXQ7XG4gICAgfSBlbHNlIGlmICh0eXBlb2YgZGF0ZUZvcm1hdCA9PT0gJ3N0cmluZycpIHtcbiAgICAgIGlucHV0VHlwZSA9ICdkYXRlJztcbiAgICAgIGZvcm1hdCA9IGRhdGVGb3JtYXQ7XG4gICAgfVxuXG4gICAgaWYgKHR5cGVvZiB1c2VyRm9ybWF0ID09PSAnc3RyaW5nJykge1xuICAgICAgZm9ybWF0ID0gdXNlckZvcm1hdDtcbiAgICAgIGlucHV0VHlwZSA9ICdkYXRldGltZS1sb2NhbCc7XG4gICAgfVxuXG4gICAgaWYgKGRhdGVGb3JtYXQgPT09IGZhbHNlKSBpbnB1dFR5cGUgPSAndGltZSc7XG4gICAgaWYgKHRpbWVGb3JtYXQgPT09IGZhbHNlKSBpbnB1dFR5cGUgPSAnZGF0ZSc7XG4gICAgaWYgKGlucHV0VHlwZSA9PT0gJ2RhdGV0aW1lLWxvY2FsJykgaW5wdXRGb3JtYXQgPSAnWVlZWS1NTS1ERFRISDptbSc7XG4gICAgaWYgKGlucHV0VHlwZSA9PT0gJ2RhdGUnKSBpbnB1dEZvcm1hdCA9ICdZWVlZLU1NLUREJztcbiAgICBpZiAoaW5wdXRUeXBlID09PSAndGltZScpIGlucHV0Rm9ybWF0ID0gJ0hIOm1tJztcblxuICAgIHJldHVybiB7IGZvcm1hdCwgaW5wdXRUeXBlLCBpbnB1dEZvcm1hdCB9O1xuICB9XG5cbiAgaXNWYWxpZERhdGUgPSBkdCA9PiBkYXlqcyhkdCwgdGhpcy5nZXRGb3JtYXQoKS5pbnB1dEZvcm1hdCkuaXNWYWxpZCgpIHx8IGR0ID09PSAnJztcblxuICBnZXROb3coKSB7XG4gICAgY29uc3QgeyBpbnB1dEZvcm1hdCB9ID0gdGhpcy5nZXRGb3JtYXQoKTtcbiAgICByZXR1cm4gdGhpcy5pc1V0YyA/IGRheWpzLnV0YygpLmZvcm1hdChpbnB1dEZvcm1hdCkgOiBkYXlqcygpLmZvcm1hdChpbnB1dEZvcm1hdCk7XG4gIH1cblxuICBmb3JtYXRJbnB1dFZhbHVlKHZhbHVlKSB7XG4gICAgaWYgKHZhbHVlID09PSAnJykgcmV0dXJuIHZhbHVlO1xuICAgIGNvbnN0IHsgZm9ybWF0LCBpbnB1dEZvcm1hdCB9ID0gdGhpcy5nZXRGb3JtYXQoKTtcblxuICAgIGlmICh0eXBlb2YgdmFsdWUgPT09ICdzdHJpbmcnICYmIHZhbHVlPy5yZXBsYWNlKC9cXHMrL2csICcnKSA9PT0gJ3t7bm93fX0nKSB7XG4gICAgICByZXR1cm4gdGhpcy5nZXROb3coKTtcbiAgICB9XG5cbiAgICBjb25zdCBpbnB1dFZhbHVlID0gdGhpcy5pc1V0Y1xuICAgICAgPyBkYXlqcy51dGModmFsdWUsIGZvcm1hdCkuZm9ybWF0KGlucHV0Rm9ybWF0KVxuICAgICAgOiBkYXlqcyh2YWx1ZSwgZm9ybWF0KS5mb3JtYXQoaW5wdXRGb3JtYXQpO1xuXG4gICAgaWYgKHRoaXMuaXNWYWxpZERhdGUoaW5wdXRWYWx1ZSkpIHtcbiAgICAgIHJldHVybiBpbnB1dFZhbHVlO1xuICAgIH1cbiAgICByZXR1cm4gdGhpcy5pc1V0YyA/IGRheWpzLnV0Yyh2YWx1ZSkuZm9ybWF0KGlucHV0Rm9ybWF0KSA6IGRheWpzKHZhbHVlKS5mb3JtYXQoaW5wdXRGb3JtYXQpO1xuICB9XG5cbiAgaGFuZGxlQ2hhbmdlID0gZGF0ZXRpbWUgPT4ge1xuICAgIGlmICghdGhpcy5pc1ZhbGlkRGF0ZShkYXRldGltZSkpIHJldHVybjtcbiAgICBjb25zdCB7IG9uQ2hhbmdlIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgaWYgKGRhdGV0aW1lID09PSAnJykge1xuICAgICAgb25DaGFuZ2UoJycpO1xuICAgIH0gZWxzZSB7XG4gICAgICBjb25zdCB7IGZvcm1hdCwgaW5wdXRGb3JtYXQgfSA9IHRoaXMuZ2V0Rm9ybWF0KCk7XG4gICAgICBjb25zdCBmb3JtYXR0ZWRWYWx1ZSA9IGRheWpzKGRhdGV0aW1lLCBpbnB1dEZvcm1hdCkuZm9ybWF0KGZvcm1hdCk7XG4gICAgICBvbkNoYW5nZShmb3JtYXR0ZWRWYWx1ZSk7XG4gICAgfVxuICB9O1xuXG4gIHNob3J0Y3V0cyh7IHQgfSkge1xuICAgIHJldHVybiB7XG4gICAgICBbdCgnZWRpdG9yLmVkaXRvcldpZGdldHMuZGF0ZXRpbWUubm93JyldOiAoKSA9PiB0aGlzLmhhbmRsZUNoYW5nZSh0aGlzLmdldE5vdygpKSxcbiAgICAgIFt0KCdlZGl0b3IuZWRpdG9yV2lkZ2V0cy5kYXRldGltZS5jbGVhcicpXTogKCkgPT4gdGhpcy5oYW5kbGVDaGFuZ2UoJycpLFxuICAgIH07XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBmb3JJRCwgdmFsdWUsIGNsYXNzTmFtZVdyYXBwZXIsIHNldEFjdGl2ZVN0eWxlLCBzZXRJbmFjdGl2ZVN0eWxlLCB0LCBpc0Rpc2FibGVkIH0gPVxuICAgICAgdGhpcy5wcm9wcztcbiAgICBjb25zdCB7IGlucHV0VHlwZSwgaW5wdXRGb3JtYXQgfSA9IHRoaXMuZ2V0Rm9ybWF0KCk7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9e2NsYXNzTmFtZVdyYXBwZXJ9PlxuICAgICAgICA8RGF0ZXRpbWVGaWVsZFxuICAgICAgICAgIG5hbWU9e2ZvcklEfVxuICAgICAgICAgIGRhdGEtdGVzdGlkPXtmb3JJRH1cbiAgICAgICAgICB0eXBlPXtpbnB1dFR5cGV9XG4gICAgICAgICAgZm9ybWF0PXtpbnB1dEZvcm1hdH1cbiAgICAgICAgICB2YWx1ZT17dmFsdWUgPyB0aGlzLmZvcm1hdElucHV0VmFsdWUodmFsdWUpIDogJyd9XG4gICAgICAgICAgZmlsbGVkXG4gICAgICAgICAgb25DaGFuZ2U9e3RoaXMuaGFuZGxlQ2hhbmdlfVxuICAgICAgICAgIG9uRm9jdXM9e3NldEFjdGl2ZVN0eWxlfVxuICAgICAgICAgIG9uQmx1cj17c2V0SW5hY3RpdmVTdHlsZX1cbiAgICAgICAgICBzaG9ydGN1dHM9eyFpc0Rpc2FibGVkICYmIHRoaXMuc2hvcnRjdXRzKHsgdCB9KX1cbiAgICAgICAgICByZWFkT25seT17aXNEaXNhYmxlZH1cbiAgICAgICAgLz5cbiAgICAgICAge3RoaXMuaXNVdGMgJiYgKFxuICAgICAgICAgIDxzcGFuXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgZm9udC1zaXplOiAwLjhlbTtcbiAgICAgICAgICAgICAgY29sb3I6ICM2NjY7XG4gICAgICAgICAgICBgfVxuICAgICAgICAgID5cbiAgICAgICAgICAgIFVUQ1xuICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgKX1cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgRGF0ZVRpbWVDb250cm9sO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
class DateTimeControl extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isUtc", this.props.field.get('picker_utc') || false);
    _defineProperty(this, "isValidDate", dt => dayjs(dt, this.getFormat().inputFormat).isValid() || dt === '');
    _defineProperty(this, "handleChange", datetime => {
      if (!this.isValidDate(datetime)) return;
      const {
        onChange
      } = this.props;
      if (datetime === '') {
        onChange('');
      } else {
        const {
          format,
          inputFormat
        } = this.getFormat();
        const formattedValue = dayjs(datetime, inputFormat).format(format);
        onChange(formattedValue);
      }
    });
  }
  escapeZ(str) {
    if (/Z(?![\]])/.test(str)) {
      return str.replace('Z', '[Z]');
    }
    return str;
  }
  getFormat() {
    const {
      field
    } = this.props;
    let inputType = 'datetime-local';
    let inputFormat = 'YYYY-MM-DDTHH:mm';
    let format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
    let userFormat = field === null || field === void 0 ? void 0 : field.get('format');
    let dateFormat = field === null || field === void 0 ? void 0 : field.get('date_format');
    let timeFormat = field === null || field === void 0 ? void 0 : field.get('time_format');
    if (dateFormat === true) dateFormat = 'YYYY-MM-DD';
    if (timeFormat === true) timeFormat = 'HH:mm';
    if (this.isUtc) {
      userFormat = this.escapeZ(userFormat);
      dateFormat = this.escapeZ(dateFormat);
      timeFormat = this.escapeZ(timeFormat);
    }
    if (typeof dateFormat === 'string' && typeof timeFormat === 'string') {
      format = `${dateFormat}T${timeFormat}`;
    } else if (typeof timeFormat === 'string') {
      inputType = 'time';
      format = timeFormat;
    } else if (typeof dateFormat === 'string') {
      inputType = 'date';
      format = dateFormat;
    }
    if (typeof userFormat === 'string') {
      format = userFormat;
      inputType = 'datetime-local';
    }
    if (dateFormat === false) inputType = 'time';
    if (timeFormat === false) inputType = 'date';
    if (inputType === 'datetime-local') inputFormat = 'YYYY-MM-DDTHH:mm';
    if (inputType === 'date') inputFormat = 'YYYY-MM-DD';
    if (inputType === 'time') inputFormat = 'HH:mm';
    return {
      format,
      inputType,
      inputFormat
    };
  }
  getNow() {
    const {
      inputFormat
    } = this.getFormat();
    return this.isUtc ? dayjs.utc().format(inputFormat) : dayjs().format(inputFormat);
  }
  formatInputValue(value) {
    if (value === '') return value;
    const {
      format,
      inputFormat
    } = this.getFormat();
    if (typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.replace(/\s+/g, '')) === '{{now}}') {
      return this.getNow();
    }
    const inputValue = this.isUtc ? dayjs.utc(value, format).format(inputFormat) : dayjs(value, format).format(inputFormat);
    if (this.isValidDate(inputValue)) {
      return inputValue;
    }
    return this.isUtc ? dayjs.utc(value).format(inputFormat) : dayjs(value).format(inputFormat);
  }
  shortcuts({
    t
  }) {
    return {
      [t('editor.editorWidgets.datetime.now')]: () => this.handleChange(this.getNow()),
      [t('editor.editorWidgets.datetime.clear')]: () => this.handleChange('')
    };
  }
  render() {
    const {
      forID,
      value,
      classNameWrapper,
      setActiveStyle,
      setInactiveStyle,
      t,
      isDisabled
    } = this.props;
    const {
      inputType,
      inputFormat
    } = this.getFormat();
    return ___EmotionJSX("div", {
      className: classNameWrapper
    }, ___EmotionJSX(DatetimeField, {
      name: forID,
      "data-testid": forID,
      type: inputType,
      format: inputFormat,
      value: value ? this.formatInputValue(value) : '',
      filled: true,
      onChange: this.handleChange,
      onFocus: setActiveStyle,
      onBlur: setInactiveStyle,
      shortcuts: !isDisabled && this.shortcuts({
        t
      }),
      readOnly: isDisabled
    }), this.isUtc && ___EmotionJSX("span", {
      css: _ref
    }, "UTC"));
  }
}
_defineProperty(DateTimeControl, "propTypes", {
  field: PropTypes.object.isRequired,
  forID: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  classNameWrapper: PropTypes.string.isRequired,
  setActiveStyle: PropTypes.func.isRequired,
  setInactiveStyle: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
});
_defineProperty(DateTimeControl, "defaultProps", {
  isDisabled: false
});
export default DateTimeControl;